import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import { ReportSharePanel } from '@/components/assessment-engine/ReportSharePanel';
import { AePageHeader, AePageShell } from '@/components/assessment-engine/layout';
import {
  AE_BTN_PRIMARY,
  AE_CARD_COMPACT,
  AE_MUTED,
  AE_SECTION_TITLE_COMPACT,
} from '@/components/assessment-engine/layout/aeTheme';

interface ReportTabProps {
  campaignId: string;
}

/** Campaign hub — report link and share links summary. */
export const ReportTab: React.FC<ReportTabProps> = ({ campaignId }) => {
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div className={AE_CARD_COMPACT}>
        <h2 className={`${AE_SECTION_TITLE_COMPACT} mb-1`}>
          {t('assessmentEngine.hub.reportSection')}
        </h2>
        <p className={`${AE_MUTED} text-xs mb-3`}>{t('assessmentEngine.hub.reportHelp')}</p>
        <Link to={`/assessment-engine/campaigns/${campaignId}/report`} className={AE_BTN_PRIMARY}>
          {t('assessmentEngine.hub.openReport')}
        </Link>
      </div>
      <ReportSharePanel campaignId={campaignId} />
    </div>
  );
};

/** Standalone shared links page (also embedded in Report tab). */
export const SharedLinksPage: React.FC<{ campaignId: string }> = ({ campaignId }) => {
  const { t } = useLanguage();

  return (
    <AePageShell>
      <AePageHeader title={t('assessmentEngine.share.title')} />
      <ReportSharePanel campaignId={campaignId} />
    </AePageShell>
  );
};
